import { localStorageTest } from "../utils/localStorageTest.js";
const LOCAL_STORAGE_AFFILIATE_NAME = "real-commerce-affiliate";
const CONSENT_API_DEFINITION = [
    "local",
    LOCAL_STORAGE_AFFILIATE_NAME,
    "*"
];
const QUERY_PARAMETER = "alv";
function getAffiliateFromCurrentUrl() {
    const params = new URLSearchParams(window.location.search);
    const hashId = params.get(QUERY_PARAMETER);
    if (!hashId) {
        return undefined;
    }
    return {
        type: "devowl",
        hashId
    };
}
/**
 * Create a local storage item from affiliate parameters. This is needed for custom affiliate
 * coding of Real Commerce backend. It always overrides the previous affiliate and does not validate
 * any expiration as this is done in Real Commerce backend.
 */ function createAffiliateStorageFromParams() {
    const localStorageValue = getAffiliateFromCurrentUrl();
    if (!localStorageValue) {
        return;
    }
    const writeLocalStorage = ()=>{
        localStorage.setItem(LOCAL_STORAGE_AFFILIATE_NAME, JSON.stringify(localStorageValue));
    };
    const addHashIdToAllLinks = ()=>{
        const links = document.querySelectorAll(`a[href^="${window.location.origin}"]`);
        links.forEach((link)=>{
            // Automatically remove leading `/` after query parameters (see https://regex101.com/r/oS9bGw/1)
            const url = new URL(link.href.replace(/([?&][^/]+)\/$/, "$1"));
            url.searchParams.set(QUERY_PARAMETER, localStorageValue.hashId);
            link.href = url.toString();
        });
    };
    if (localStorageTest()) {
        const { consentApi } = window;
        const waitConsent = (consentApi == null ? void 0 : consentApi.consent(...CONSENT_API_DEFINITION)) || Promise.resolve();
        waitConsent.then(writeLocalStorage).catch(addHashIdToAllLinks);
    } else {
        addHashIdToAllLinks();
    }
}
export { getAffiliateFromCurrentUrl, createAffiliateStorageFromParams, LOCAL_STORAGE_AFFILIATE_NAME };
